import React, { useState } from "react";
import { ReactComponent as XIcon } from "../../../assets/svg/x.svg";
import styles from "./PostulationItem.module.scss";
import { useHistory } from "react-router-dom";

const PostulationItem = ({ postulation, coverImage }) => {
    const [showPostulation, setShowPostulation] = useState(false);

    const history = useHistory();

    const handleShowPostulation = () => {
        setShowPostulation(!showPostulation);
    }

    //Formateamos fechas
    const formatDate = (date) => {
        if (date && typeof date === "string") {
            const fecha = new Date(date);
            return fecha.toLocaleDateString();
        }
        return "";
    };

    const handleRedirectToProject = () => {
          history.push(`/proyectosprivados/${postulation.proyecto.id}`);  
      };

    const translateStatusPostulation = (status) => {
        switch (status) {
            case 'SEND':
                return 'Postulacion pendiente';
            case 'ALLOWED':
                return 'Postulacion aceptada';
            case 'DENIED':
                return 'Postulacion rechazada';
            default:
                return '';
        }
    }

    return (
        <>
            <div className={styles.container}>
                <div className={styles.container_image}>
                    <img className={styles.container_image_img} src={coverImage} alt="postulation" />
                </div>
                <div className={styles.container_info}>
                    <div className={styles.container_info_text} onClick={() => handleRedirectToProject()}>
                        <p><b>Proyecto:</b> {postulation?.proyecto?.name}</p>
                        <p>{postulation?.proyecto?.description}</p>
                    </div>
                    <div className={styles.container_info_button} onClick={() => handleShowPostulation()}>
                        <div >Ver más</div>
                    </div>
                </div>
               <div className={`${styles.container_postulationStatus} ${postulation?.status === "SEND" && styles.postulationSend} 
                    ${postulation?.status === "ALLOWED" && styles.postulationAllowed} ${postulation?.status === "NEGATED" && styles.postulationDenied}`}>
                <p>{translateStatusPostulation(postulation?.status)}</p>
            </div> 
            </div>
            
            {showPostulation && (
                <div className={styles.container_portfolio}>
                    <div className={styles.container_portfolio_container}>
                        <div className={styles.container_portfolio_close} onClick={() => handleShowPostulation()}>
                            <XIcon width={18} height={18} />
                        </div>
                        <div className={styles.container_portfolio_container_content}>
                            <div className={styles.container_portfolio_info}>
                                <h2 className={styles.container_portfolio_info_title} onClick={() => handleRedirectToProject()}>{postulation?.proyecto?.name}</h2>
                                <div className={styles.container_portfolio_info_text}>
                                    <h3 className={styles.container_portfolio_info_subTitle}>Descripción</h3>
                                    <p className={styles.container_portfolio_info_subTitle_txt}>{postulation?.proyecto?.description}</p>
                                </div>
                                <div className={styles.container_portfolio_info_boxes}>
                                    <div className={styles.container_portfolio_info_boxes_zone}>
                                        <h3 className={styles.container_portfolio_info_subTitle}>Zona</h3>
                                        <p className={styles.container_portfolio_info_subTitle_txt}>{postulation?.proyecto?.zone}</p>
                                    </div>
                                    <div className={styles.container_portfolio_info_boxes_start}>
                                        <h3 className={styles.container_portfolio_info_subTitle}>Inicio</h3>
                                        <p className={styles.container_portfolio_info_subTitle_txt}>{formatDate(postulation?.proyecto?.startDate)}</p>
                                    </div>
                                    <div className={styles.container_portfolio_info_boxes_end}>
                                        <h3 className={styles.container_portfolio_info_subTitle}>Fin</h3>
                                        <p className={styles.container_portfolio_info_subTitle_txt}>{formatDate(postulation?.proyecto?.endDate)}</p>
                                    </div>
                                </div>

                            </div>
                            <div className={styles.container_portfolio_images}>
                                {postulation?.proyecto?.proyecto_images.map((image, index) => (
                                    <div key={index} className={styles.container_portfolio_images_item}>
                                        <img className={styles.container_portfolio_images_item_img} src={image.image} alt="portfolio" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
};

export default PostulationItem;
